<template>
  <div>
    <p>
      <img
        :src="content.attrs.src"
        class="image"
        alt="Image"
      />
    </p>
  </div>
</template>

<script>

export default {
  name: 'ImageBlock',
  props: ['content']
}
</script>

<style lang="scss" scoped>
/* IMAGE */
::v-deep {
}

</style>
